export default __webpack_public_path__ + "images/referrals-onboarding-step-4.2ac0163aa347ceb7d24efe4cb92862e6.svg";